import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  CContainer,
  CCard,
  CCardBody,
  CCardHeader,
  CButton,
  CSpinner,
  CListGroup,
  CListGroupItem,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilArrowLeft, cilFolder, cilFolderOpen, cilFile } from "@coreui/icons";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const DocumentationCategory = ({ category }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <CListGroupItem className="border-0 p-0 mb-2">
      <div
        className="d-flex align-items-center p-2 rounded bg-light"
        style={{ cursor: "pointer" }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <CIcon
          icon={isOpen ? cilFolderOpen : cilFolder}
          className="me-2 text-warning"
          size="lg"
        />
        <span className="fw-bold">{category.name}</span>
      </div>

      {isOpen && (
        <div className="ps-4 mt-2 border-start ms-3">
          {category.subcategories &&
            category.subcategories.map((sub) => (
              <DocumentationCategory key={sub.id} category={sub} />
            ))}

          <CListGroup flush>
            {category.documents &&
              category.documents.map((doc) => (
                <CListGroupItem
                  key={doc.id}
                  className="border-0 bg-transparent py-1"
                >
                  <a
                    href={doc.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <CIcon icon={cilFile} className="me-2 text-info" />
                    {doc.title}
                  </a>
                </CListGroupItem>
              ))}
            {category.documents.length === 0 &&
              category.subcategories.length === 0 && (
                <span className="text-muted small">
                  {t("docs.empty_category")}
                </span>
              )}
          </CListGroup>
        </div>
      )}
    </CListGroupItem>
  );
};

const DocumentationPage = () => {
  const { t } = useTranslation();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get("/api/documentation/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDocs(response.data);
      } catch (err) {
        toast.error(t("common.error"));
      } finally {
        setLoading(false);
      }
    };
    fetchDocs();
  }, [t]);

  return (
    <div className="bg-light min-vh-100 p-3 p-md-4">
      <CContainer fluid>
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 page-header-mobile">
          <h2>{t("docs.title")}</h2>
          <CButton
            color="secondary"
            as={Link}
            to="/dashboard"
            className="btn-mobile-100"
          >
            <CIcon icon={cilArrowLeft} className="me-2" /> {t("common.back")}
          </CButton>
        </div>

        <CCard className="shadow-sm border-0">
          <CCardHeader className="bg-white fw-bold">
            {t("docs.knowledge_base")}
          </CCardHeader>
          <CCardBody>
            {loading ? (
              <div className="text-center p-5">
                <CSpinner />
              </div>
            ) : docs.length > 0 ? (
              <CListGroup flush>
                {docs.map((cat) => (
                  <DocumentationCategory key={cat.id} category={cat} />
                ))}
              </CListGroup>
            ) : (
              <div className="text-center text-muted p-5">
                {t("docs.empty")}
              </div>
            )}
          </CCardBody>
        </CCard>
      </CContainer>
    </div>
  );
};

export default DocumentationPage;